<template>
    <div>
        <b-row>
            <b-col cols="4">
                <b-btn
                    block
                    size="sm"
                    variant="primary"
                    title="Limpiar campos"
                    @click="edit(theProspect)"
                >
                    <i class="fa fa-edit" aria-hidden="true"></i> Editar
                </b-btn>
            </b-col>
        </b-row>
        <div class="client-card">
            <div class="card">
                <div class="card-body">
                    <div class="card-title">
                        <h4>Datos adicionales del prospecto</h4>
                    </div>
                    <table class="table table-sm" v-if="!!theProspect">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td class="column-field">Descripción:</td>
                                <td>{{ theProspect.description }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Nombre del contacto principal:</td>
                                <td>{{ theProspect.main_contact }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Cargo:</td>
                                <td>{{ theProspect.work_position }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Face del proceso:</td>
                                <td>
                                    {{ !!theProspect && !!theProspect.commercial_phase ?
                                    theProspect.commercial_phase.name : '' }}
                                </td>
                            </tr>
                            <tr>
                                <td class="column-field">Perfil del contacto:</td>
                                <td>
                                    {{ !!theProspect && !!theProspect.contact_profile ?
                                    theProspect.contact_profile.name : '' }}
                                </td>
                            </tr>
                            <tr>
                                <td class="column-field">Motivo dominante de compra:</td>
                                <td>{{ theProspect.reason_for_purchase }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Resumen de la gestión realizada:</td>
                                <td>{{ theProspect.management_performed }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Siguiente paso en el proceso</td>
                                <td>{{ theProspect.next_step_process }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Objetivos de la siguiente visita</td>
                                <td>{{ theProspect.objetives_next_visit }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Estrategia</td>
                                <td>{{ theProspect.strategy }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Fecha de entrega de propuesta:</td>
                                <td>
                                    {{
                                    theProspect.proposal_delivery_date
                                    | date
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td class="column-field">Fecha probable de inicio:</td>
                                <td>{{ theProspect.probable_start_date | date }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Proveedor actual:</td>
                                <td>{{ theProspect.current_provider }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Facturación estimada al año:</td>
                                <td>
                                    {{
                                    theProspect.estimated_bill_to_year
                                    | currency
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td class="column-field">Aspectos relevantes para la propuesta:</td>
                                <td>{{ theProspect.relevant_aspects }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Planeacion de la visita:</td>
                                <td>{{ theProspect.visit_planning }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Inversión estimada:</td>
                                <td>
                                    {{
                                    theProspect.estimated_investment
                                    | currency
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td class="column-field">Inversión operativa:</td>
                                <td>
                                    {{
                                    theProspect.operational_investment
                                    | currency
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td class="column-field">Herramientas y equipo:</td>
                                <td>{{ theProspect.tools_or_equipment }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Probabilidades de ganar:</td>
                                <td>{{ theProspect.probability_of_winning }}</td>
                            </tr>
                            <tr>
                                <td class="column-field">Resultados:</td>
                                <td>{{ theProspect.results }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-alert variant="info" show v-else>Aún no hay información Comercial registrada</b-alert>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        theProspect: {
            type: [Array, Object],
        },
    },
    methods: {
        edit(item) {
            this.$router.push({
                name: 'ClientProspectForm',
                params: {
                    theCommercialInfo: item,
                },
            })
        },
    },
}
</script>
<style scoped>
.column-field {
    width: 30%;
    font-weight: bold;
}
</style>
